import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminSidebar from "../shared/AdminSidebar";
import "./AdminDocument.css";

const AdminDocument = () => {
  const [documents, setDocuments] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get_documents.php`
      );

      if (response.data.success) {
        setDocuments(response.data.documents);
      } else {
        toast.error("Failed to fetch documents: " + response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred while fetching the documents.");
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file to upload.");
      return;
    }
    if (!titre.trim()) {
      toast.error("Veuillez saisir le titre du document.");
      return;
    }
    if (!description.trim()) {
      toast.error("Veuillez saisir la description du document.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("titre", titre);
    formData.append("description", description);

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/upload_document.php`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Document uploaded successfully!");
        fetchDocuments();
        setSelectedFile(null);
        setTitre("");
        setDescription("");
      } else {
        toast.error("Failed to upload document: " + response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred while uploading the document.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (docId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/delete_document.php`,
        { id: docId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Document deleted successfully!");
        fetchDocuments();
      } else {
        toast.error("Failed to delete document: " + response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred while deleting the document.");
    }
  };

  return (
    <div className="layout">
      {/* Sidebar */}
      <AdminSidebar />

  {/* Main Content */}
  <div className="main-content admin-content main-content-center">
        <div className="admin-document-page">
          <ToastContainer />
          <h1>Gérer les documents</h1>
          <div className="upload-section upload-section-center">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleUpload();
              }}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                maxWidth: "400px",
              }}
            >
              <label>
                Titre du document:
                <input
                  type="text"
                  value={titre}
                  onChange={(e) => setTitre(e.target.value)}
                  placeholder="Titre du document"
                  required
                />
              </label>
              <label>
                Description:
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Description du document"
                  required
                  rows={3}
                />
              </label>
              <input type="file" onChange={handleFileChange} />
              <button type="submit" disabled={loading}>
                {loading ? "Uploading..." : "Uploader"}
              </button>
            </form>
          </div>
          <button
            className="show-documents-btn"
            onClick={() => setShowModal(true)}
          >
            Afficher les documents
          </button>
          {showModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <button
                  className="close-modal-btn"
                  onClick={() => setShowModal(false)}
                  title="Fermer"
                >
                  &times;
                </button>
                <h2>Liste des documents</h2>
                <ul className="document-list">
                  {documents.length === 0 && (
                    <li style={{ textAlign: "center", color: "#888" }}>
                      Aucun document disponible.
                    </li>
                  )}
                  {documents.map((doc, idx) => (
                    <li
                      key={doc.id || doc.url || idx}
                      className="document-item"
                    >
                      <a
                        href={doc.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={doc.name}
                        style={{ textTransform: "capitalize" }}
                      >
                        {doc.name.length > 40
                          ? doc.name.slice(0, 37) + "..."
                          : doc.name}
                      </a>
                      <button onClick={() => handleDelete(doc.id)}>
                        Supprimer
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDocument;
